import { Box, ColorOptions, convertHexToRGBA, ModBox, Spacer } from '@jfs/ui-new'
import { FC, useCallback, useEffect, useRef, useState } from 'react'
import { Dimensions, FlatList } from 'react-native'
import { TableComponent } from '../../../comps/TableComponent'
import { Colors, isOsMobile } from '../../../util/util'
import CarousalItem from './CarousalItem'
import styles from './styles'
import { CarousalItemData } from './types'

const BannerCarousal: FC<any> = ({ data: dataProp, onPressBanner }: any) => {
  const { width } = Dimensions.get('screen')
  const scroller = useRef<FlatList<CarousalItemData>>(null)
  const timeoutRef = useRef(null)
  const itemWidth = width

  const getItemoffset = (index: number) => index * itemWidth
  const [selectedIndex, setSelectedIndex] = useState(0)
  const selectedIndexRef = useRef<number>()
  selectedIndexRef.current = selectedIndex

  const onScroll = (event: any) => {
    const currentlySelected = Math.floor(event.nativeEvent.contentOffset.x / itemWidth + 0.5)
    if (currentlySelected !== selectedIndex) {
      setSelectedIndex(currentlySelected)
    }
  }

  const callback = useCallback(() => {
    timeoutRef.current = setTimeout(() => {
      if (selectedIndexRef.current < dataProp.length - 1) {
        scroller?.current?.scrollToOffset({
          offset: getItemoffset(selectedIndexRef.current + 1),
          animated: true,
        })
      } else {
        scroller?.current?.scrollToOffset({
          offset: getItemoffset(0),
          animated: true,
        })
      }
    }, 4000)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedIndexRef.current, dataProp.length])

  useEffect(() => {
    callback()
    return () => clearTimeout(timeoutRef.current)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedIndexRef.current, dataProp.length])

  const pause = () => {
    if (timeoutRef?.current) {
      clearTimeout(timeoutRef.current)
    }
  }

  const resume = () => {
    callback()
  }

  const renderItem = ({ item }: any) => {
    return (
      <Box>
        <CarousalItem onPressBanner={onPressBanner} data={item} />
      </Box>
    )
  }
  let snapToOffsets
  let getItemLayout
  let decelerationRate: 'fast' | 'normal' | number | undefined
  let disableIntervalMomentum: boolean | undefined

  return (
    <Box {...styles.container} justify={'space-between'}>
      <TableComponent
        value={''} //Routes value
        canFetchMore={false}
        hide={false}
        isCustom={true}
        ListContent={dataProp ?? []}
        horizontal={true}
        RenderCustomElement={renderItem}
        contentContainerStyle={styles.listContainerStyle}
        customStyle={styles.flatListStyle}
        keyExtractor={(item) => item.key.toString()}
        onScroll={onScroll}
        decelerationRate={decelerationRate}
        disableIntervalMomentum={disableIntervalMomentum}
        pagingEnabled={true}
        snapToOffsets={snapToOffsets}
        getItemLayout={getItemLayout}
        innerRef={scroller}
        onScrollBeginDrag={pause}
        onScrollEndDrag={resume}
      />

      <ModBox show={dataProp?.length > 1} flexDirection={'row'} align={'center'} justify="center">
        {dataProp?.map((item, index) => {
          return (
            <Box
              key={'dot_' + index}
              bg={selectedIndex === index ? 'PRIMARY' : (convertHexToRGBA(Colors.PRIMARY, 50) as ColorOptions)}
              w={selectedIndex === index ? 18 : 8}
              h={8}
              borderRadius={4}
              overflow="hidden"
              marginHorizontal={3}
            />
          )
        })}
      </ModBox>
      <Spacer size={isOsMobile() ? 0 : 24} direction={'vertical'} />
    </Box>
  )
}
export default BannerCarousal
